import React from 'react';
import { Link } from 'react-router-dom';

import { Avatar, Box, IconButton, Snackbar, Typography } from '@mui/material';

import { DRAWER_WIDTH } from '../Layout/constant';
import { VennueAccessRequestItem } from '../../graphql/API';
import Icons from '../../themes/icons';

type Props = {
  accessRequest: VennueAccessRequestItem | null;
  open: boolean;
  onClose: () => void;
};

export const AccessRequestAlert: React.FC<Props> = ({ accessRequest, open, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      sx={{
        top: { xs: '24px !important', md: '180px !important' },
        left: { xs: 24, md: `${DRAWER_WIDTH + 30}px !important` },
      }}
    >
      <Box
        sx={{
          borderRadius: '8px',
          backgroundColor: '#DDF4E8',
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Avatar
          sx={{ width: 34, height: 34 }}
          variant='circular'
          alt={accessRequest?.user?.firstname}
          src={String(accessRequest?.user?.picture?.medium)}
        />
        <Typography fontSize={'15px'} fontWeight={'400'}>
          You have accepted{' '}
          <b>
            {accessRequest?.user?.firstname} {accessRequest?.user?.lastname}
          </b>{' '}
          request, you can now track her reservation{' '}
          <Link to='/reservations' style={{ fontWeight: 700, color: '#111' }}>
            here
          </Link>
        </Typography>
        <IconButton
          onClick={onClose}
          size='small'
          sx={{
            ml: '24px',
            width: 24,
            height: 24,
            border: '1px solid #111',
            borderRadius: '50%',
            color: '#111',
            flexShrink: 0,
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.06)' },
          }}
        >
          <Icons.CloseIcon sx={{ width: 14, height: 14 }} />
        </IconButton>
      </Box>
    </Snackbar>
  );
};

export const BulkAccessRequestAlert: React.FC<Omit<Props, 'accessRequest'>> = ({ open, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      sx={{
        top: { xs: '24px !important', md: '180px !important' },
        left: { xs: 24, md: `${DRAWER_WIDTH + 30}px !important` },
      }}
    >
      <Box
        sx={{
          borderRadius: '8px',
          backgroundColor: '#DDF4E8',
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Typography fontSize={'15px'} fontWeight={'400'}>
          You have accepted request, you can now track her reservation{' '}
          <Link to='/reservations' style={{ fontWeight: 700, color: '#111' }}>
            here
          </Link>
        </Typography>
        <IconButton
          onClick={onClose}
          size='small'
          sx={{
            ml: '24px',
            width: 24,
            height: 24,
            border: '1px solid #111',
            borderRadius: '50%',
            color: '#111',
            flexShrink: 0,
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.06)' },
          }}
        >
          <Icons.CloseIcon sx={{ width: 14, height: 14 }} />
        </IconButton>
      </Box>
    </Snackbar>
  );
};
